import {storeInstance} from '@aofl/store/dist/legacy';
import {
  printReportTypes,
  sdoNs,
} from '@modules/constants-enumerate';
import '@modules/session-sdo';
import {deepAssign} from '@aofl/object-utils';
import {dateTimeFormatter} from '@modules/i18n-datetime';
import {parse} from 'date-fns';
const sdo = {
  namespace: sdoNs.PRINT_REPORTS,
  mutations: {
    init() {
      return {
        tiers: {},
        students: [],
        reports: [],
        dates: [],
        selected: {
          groups: [],
          student: {},
          reportType: {},
          date: {},
          standard: {},
          months: {},
        }
      };
    },
    setSelected(subState, payload) {
      const {sectionInfo, selected} = payload;
      let {reports, dates} = subState;
      const {objectType} = sectionInfo;
      const objectTypeToKeyMap = {
        'students': 'student',
        'report_types': 'reportType',
        'dates': 'date',
        'months': 'months'
      };
      const key = objectTypeToKeyMap[objectType] || objectType;
      const selectedState = {
        ...subState.selected,
        [key]: selected
      };

      switch (objectType) {
        case 'students':
          selectedState.standard = {};
          selectedState.date = {};
          selectedState.reportType = {};
          selectedState.months = [];
          reports = [];
          dates = [];
          break;
        case 'report_types':
          selectedState.standard = {};
          selectedState.date = {};
          selectedState.months = [];
          dates = [];
          break;
        case 'external_standards':
          selectedState.date = {};
          selectedState.months = [];
          dates = [];
          break;
      }
      return deepAssign(subState, '', {
        selected: selectedState,
        dates: [...dates],
        reports: [...reports],
      });
    },
    setSelectedGroups(subState, payload) {
      const {groupInfo, index} = payload;
      const selectedGroups = [...subState.selected.groups];
      const tiers = {...subState.tiers};
      selectedGroups[index] = groupInfo;
      selectedGroups.splice(index + 1);

      for (const [level, items] of Object.entries(tiers)) {
        if (level > index) {
          delete tiers[level];
        }
      }
      return deepAssign(subState, '', {
        date: {},
        standard: {},
        reportType: {},
        student: {},
        reports: [],
        standards: [],
        students: [],
        dates: [],
        tiers,
        selected: {
          ...subState.selected,
          groups: selectedGroups,
          student: {},
          date: {},
          reportType: {},
          grade: '',
        }
      });
    },
    setNextDropdowns(subState, dropdowns) {
      let {tiers, students, standards, reports, dates} = subState;
      const tierCount = subState.selected.groups.length;
      dropdowns.map((dropdown) => {
        const objectType = dropdown.object_type;
        switch (objectType) {
          case 'groups':
            tiers = {
              ...tiers,
              [tierCount]: [...dropdown.items]
            };
            break;
          case 'students':
            students = [...dropdown.items];
            break;
          case 'report_types':
            reports = [...dropdown.items];
            break;
          case 'dates':
            dates = [...dropdown.items];
            break;
        }
      });
      return deepAssign(subState, '', {
        tiers,
        students,
        standards,
        reports,
        dates
      });
    },
    setGrade(subState, grade) {
      return deepAssign(subState, '', {
        selected: {
          ...subState.selected,
          grade,
        }
      });
    },
  },
  decorators: [
    (nextState) => { // $tiers
      const nextSubState = nextState[sdoNs.PRINT_REPORTS];
      const state = storeInstance.getState();
      const subState = state[sdoNs.PRINT_REPORTS];

      if (typeof nextSubState.$tiers === 'undefined' ||
        nextSubState.tiers !== subState.tiers
      ) {
        const tiers = nextSubState.tiers;
        const levels = Object.keys(tiers);
        levels.sort();
        const $tiers = [];
        levels.map((level) => {
          $tiers.push(tiers[level]);
        });
        nextState = deepAssign(nextState, sdoNs.PRINT_REPORTS, {
          $tiers
        });
      }
      return nextState;
    },
    (nextState) => { // $reportDate, $reportDatesByMonth
      const nextSubState = nextState[sdoNs.PRINT_REPORTS];
      const state = storeInstance.getState();
      const subState = state[sdoNs.PRINT_REPORTS];

      if (typeof nextSubState.$reportDate === 'undefined' ||
        (nextSubState.selected.date !== subState.selected.date &&
          nextSubState.selected.date !== '') ||
          nextSubState.selected.months !== subState.selected.months
      ) {
        let $reportDate = '';
        let $reportDatesByMonth = [];
        if (Object.keys(nextSubState.selected.date).length) {
          const date = nextSubState.selected.date;
          if (date.value !== '' && nextSubState.selected.reportType.value !== 'growth') {
            const dateFromString = parse(date.value, 'yyyy-LL-dd', new Date());
            $reportDate = dateTimeFormatter.format(dateFromString, {year: 'numeric', day: '2-digit', month: '2-digit'});
          }
        }

        if (nextSubState.selected.reportType.value === 'growth') {
          $reportDatesByMonth = nextSubState.selected.months;
        }

        nextState = deepAssign(nextState, sdoNs.PRINT_REPORTS, {
          $reportDate,
          $reportDatesByMonth
        });
      }
      return nextState;
    },
  ],
};

storeInstance.addState(sdo);
